import { gsap } from 'gsap';

const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelector('.js-menu-button');
    const stopScrollingClass = 'stop-scrolling';
    const primaryNavItems =  document.querySelectorAll('.primary-nav__list a');
    const lowerNavItems =  document.querySelectorAll('.primary-nav__lower p, .primary-nav__lower a');
    const isActiveClass = 'is-active';
    let isActive = false;

    menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        isActive = !isActive;

        if (isActive) {
            body.classList.add(stopScrollingClass, isActiveClass);
            menuToggle.textContent = 'Close';

            gsap.set(primaryNavItems, {
                opacity: 0,
                xPercent: -20
            })

            gsap.set(lowerNavItems, {
                opacity: 0,
                y: -25
            })

            gsap.to(primaryNavItems, {
                opacity: 1,
                xPercent: 0,
                stagger: .125,
                ease: 'power3.out',
                duration: .5,
            })

            gsap.to(lowerNavItems, {
                opacity: 1,
                y: 0,
                stagger: .125,
                ease: 'power3.out',
                duration: .5,
                delay: .3
            })
            
        } else {
            body.classList.remove(stopScrollingClass, isActiveClass);
            menuToggle.textContent = 'Menu'
        }
    });
};

export { initMenu as default };
